<ion-content>
  <div class="px-4 py-2 padding-bottom-configuration">
    <app-header-configuration
      [title]="'P00076.installation.vannes.title' | translate"
      [description]="'P00076.installation.vannes.description' | translate"
    >
    </app-header-configuration>

    <app-label-configuration
      [title]="'P00076.installation.vannes.remplissage.title' | translate"
      [description]="
        'P00076.installation.vannes.remplissage.helper' | translate
      "
      [titleListe]="
        'P00076.installation.vannes.remplissage.listTitle' | translate
      "
      [value]="actionStack!.getValue('coIPresenceVanneRemplissage')"
      [liste]="P00076VanneInstallationTypeEnum"
      (onPress)="
        this.actionStack!.editValue(
          P00039DataRxTxIndex.Constance_Installation,
          'coIPresenceVanneRemplissage',
          $event,
          null
        )
      "
    >
    </app-label-configuration>

    <app-label-configuration
      [title]="'P00076.installation.vannes.vidange.title' | translate"
      [description]="'P00076.installation.vannes.vidange.helper' | translate"
      [titleListe]="'P00076.installation.vannes.vidange.listTitle' | translate"
      [value]="actionStack!.getValue('coIPresenceVanneVidange')"
      [liste]="P00076VanneInstallationTypeEnum"
      (onPress)="
        this.actionStack!.editValue(
          P00039DataRxTxIndex.Constance_Installation,
          'coIPresenceVanneVidange',
          $event,
          null
        )
      "
    >
    </app-label-configuration>
  </div>
</ion-content>

<div class="position-absolute start-0 end-0 bottom-0 bg-white px-4 py-2">
  <div class="row">
    <div class="col-6 text-start">
      <ion-button
        color="medium"
        expand="block"
        fill="outline"
        class="mb-3"
        (click)="this.prev()"
      >
        {{ 'generic.retour' | translate }}
      </ion-button>
    </div>
    <div class="col-6 text-end">
      <ion-button color="primary" expand="block" (click)="onSubmit()">
        {{ 'generic.next' | translate }}
      </ion-button>
    </div>
  </div>
</div>
